export default {"src":"/_next/static/media/mk.32a0829b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};